document.addEventListener("turbolinks:load", function() {
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('page');

    if (myParam && myParam !== "1") {
        const element = document.getElementById("subsidies-content");
        if (element) {
            window.scrollTo({
                top: element.getBoundingClientRect().top + window.scrollY - 20,
                behavior: "smooth"
            });
        }
    }
});
